export default {
  MIN_SITE_NAME_CHARS: 3,
  MAX_SITE_NAME_CHARS: 56,
  MIN_BUSINESS_DESCRIPTION_CHARS: 15,
  MAX_BUSINESS_DESCRIPTION_CHARS: 1000,
  MAX_ADDRESS_CHARS: 100,
  MAX_BUSINESS_HOUR_CHARS: 100,
};
